import { z } from "zod";

export const ZDetaljkontrollSchema = z.object({
  // 3
  isActive: z.boolean().default(true),
  tekst: z.string(),
  prosjektspesifikkeDetaljsnitt: z.object({
    // 3.1
    isActive: z.boolean().default(true),
    tekst: z.string(),
  }),
});

export type IDetaljkontrollSchema = z.infer<typeof ZDetaljkontrollSchema>;
